import React, { ReactElement } from 'react';
import Link from 'next/link';

const CallToAction = (): ReactElement => {
  return (
    <section className='freight-forwarder-landing__cta'>
      <div className="container">
        <div className='freight-forwarder-landing__cta-content'>
          <h2 className='freight-forwarder-landing__cta-title'>
            Join the Digital Freight Alliance
          </h2>
          <p className='freight-forwarder-landing__cta-description'>
            Making sure that you have the right insurance coverage is essential for protecting
            your business from potential risks associated with freight forwarding, such as cargo
            loss or damage, and liability claims. Ensure that your business is covered with
            comprehensive insurance policies tailored to the logistics sector- you can discuss
            insurance with our experts when you Join the Digital Freight Alliance.
          </p>
          <Link className="new-link-block full" href="/membership">
            Join Membership Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;